export interface CustomSocialLinksProfile {
  name: string;
  /** Used to craft the URL */
  matches: CustomSocialLinksProfileMatcher[];
}

export interface CustomSocialLinksProfileMatcher {
  /** Takes input and returns profileId string */
  match: (input: string) => string;
  /** Used to craft the URL */
  pattern: string;
  /** type Mobile / Desktop*/
  type?: number;
}

export class CustomSocialLinks {
  profiles: Map<string, CustomSocialLinksProfile> = new Map<string, CustomSocialLinksProfile>();

  addProfile(profile: string, matches: CustomSocialLinksProfileMatcher[]);
  addProfile(profile: CustomSocialLinksProfile);

  addProfile(profile: unknown, matches?: CustomSocialLinksProfileMatcher[]) {
    if (typeof profile === 'string') {
      this.profiles.set(profile, {
        name: profile,
        matches
      });
    } else {
      const tProfile = profile as CustomSocialLinksProfile;
      this.profiles.set(tProfile.name, tProfile);
    }
  }

  removeProfile(profile: string) {
    this.profiles.delete(profile);
  }

  hasProfile(profile: string) {
    return this.profiles.has(profile);
  }

  getProfileId(profile: string, input: string): string {
    const matchers = this.profiles.get(profile).matches;
    const results = matchers.map((matcher) => {
      try {
        return { profile, profileId: matcher.match(input), type: matcher.type };
      } catch {
        return { profile, profileId: null, type: matcher.type };
      }
    });

    return results.find(t => t.profileId?.length >= 1)?.profileId;
  }

  sanitize(profile: string, input: string, type?: number): string {
    const matchers = this.profiles.get(profile).matches;
    // Default to first?
    let matcher = this.profiles.get(profile).matches[0];

    if (type != null) {
      matcher = matchers.find(m => m.type === type);
    }

    const profileId = this.getProfileId(profile, input);

    if (profileId == null) {
      return null;
    }

    return matcher.pattern.replace('{PROFILE_ID}', profileId);
  }

  isValid(profile: string, input: string): boolean {
    try {
      return !!this.getProfileId(profile, input);
    } catch {
      return false;
    }
  }
}
